export const chainRewards = {
  methods: {
    extractClaimedAssets(claimResult) {
      if (!claimResult) return [];
      const candidates = [
        claimResult.assets,
        claimResult.rewards,
        claimResult.granted,
        claimResult.items,
        claimResult.package && claimResult.package.assets,
      ];
      const found = candidates.find((c) => Array.isArray(c) && c.length);
      return found || [];
    },
    parseRewardsFromAssets(assets) {
      const rewards = {
        gold: 0,
        crown: 0,
        loyalty: 0,
        elixir: 0,
        card: 0,
        expbooster: 0,
      };

      if (!assets || !Array.isArray(assets)) {
        return rewards;
      }

      assets.forEach((asset) => {
        let type = "";

        if (asset.asset_type || asset.assetType || asset.type) {
          type = (
            asset.asset_type ||
            asset.assetType ||
            asset.type
          ).toLowerCase();
        } else if (asset.asset) {
          const className = asset.asset;
          const lastBackslash = className.lastIndexOf("\\");
          type = (
            lastBackslash >= 0
              ? className.substring(lastBackslash + 1)
              : className
          ).toLowerCase();
        }

        const amount = parseInt(asset.amount, 10) || 0;

        switch (type) {
          case "gold":
            rewards.gold += amount;
            break;
          case "crown":
            rewards.crown += amount;
            break;
          case "loyalty":
            rewards.loyalty += amount;
            break;
          case "elixir":
            rewards.elixir += amount;
            break;
          case "expbooster":
            rewards.expbooster += amount;
            break;
          case "card":
            rewards.card += amount;
            break;
        }
      });

      return rewards;
    },
    // Normalize one asset's type (asset_type / assetType / type, or a PHP class
    // path like "App\\...\\Gold") to a lowercase reward key.
    assetTypeOf(asset) {
      if (asset.asset_type || asset.assetType || asset.type) {
        return (
          asset.asset_type ||
          asset.assetType ||
          asset.type
        ).toLowerCase();
      }
      if (asset.asset) {
        const className = asset.asset;
        const i = className.lastIndexOf("\\");
        return (i >= 0 ? className.substring(i + 1) : className).toLowerCase();
      }
      return "";
    },
    // Map package assets → the reward-array shape AnimationFullRewardEarnedAnimate
    // expects: [{ reward: "gold", amount }, { reward: "card", amount, cardId }].
    buildRewardAnimationArray(assets) {
      if (!Array.isArray(assets)) return [];
      const arr = [];
      assets.forEach((asset) => {
        const type = this.assetTypeOf(asset);
        const amount = parseInt(asset.amount, 10) || 0;
        if (!amount) return;
        switch (type) {
          case "gold":
          case "crown":
          case "loyalty":
          case "elixir":
          case "expbooster":
            arr.push({ reward: type, amount });
            break;
          case "card": {
            const cardId = asset.card_id ?? asset.cardId ?? asset.card?.id;
            if (cardId) arr.push({ reward: "card", amount, cardId });
            else arr.push({ reward: "cardpack", amount });
            break;
          }
        }
      });
      return arr;
    },
  },
};
